import { Link } from 'react-router-dom';
import { Tooltip, Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

import routes from '@routes';

import useAnimatedLabel from '@common/hooks/use-animated-label';
import { useFlagFixed } from '@common/utils/flags/use-flag-fixed';
import { Flags } from '@common/utils/flags/feature-flags';
import { AnalyticsEvents } from '@common/utils/analytics/events';
import { useMemo } from 'react';

export default function NewRequest({ minimized, enableAnimation }: { minimized?: boolean; enableAnimation?: boolean }) {
  const labelVisible = useAnimatedLabel({ visible: minimized, enabled: enableAnimation });
  const { isEnabled: isEntitlementRequestEnabled } = useFlagFixed(Flags.ENTITLEMENT_REQUEST_FORM);
  const { isEnabled: isHideIntegrationRequestForm } = useFlagFixed(Flags.HIDE_INTEGRATION_REQUEST_FORM);

  const toRoute = useMemo(() => {
    if (isHideIntegrationRequestForm && !isEntitlementRequestEnabled) {
      return routes.BundleRequest.path;
    } else if (isEntitlementRequestEnabled) {
      return routes.ResourcesRequest.path;
    }
    return routes.NewRequest.path;
  }, [isHideIntegrationRequestForm, isEntitlementRequestEnabled]);

  if (!labelVisible) {
    return (
      <Tooltip title="New Request" arrow placement="right">
        <Button
          fullWidth
          variant="contained-icon-only"
          size="small"
          component={Link}
          to={toRoute}
          endIcon={<AddIcon fontSize="inherit" />}
        />
      </Tooltip>
    );
  }

  return (
    <Button
      startIcon={<AddIcon fontSize="inherit" />}
      fullWidth
      variant="contained"
      size="small"
      component={Link}
      to={toRoute}
      data-trigger={AnalyticsEvents.NewRequestButtonClicked}
    >
      New Request
    </Button>
  );
}
